export default __webpack_public_path__ + "static/media/minicard1.b3561d2f.jpg";